import { render, staticRenderFns } from "./chatRecordQuery.vue?vue&type=template&id=3aaa54a2&scoped=true"
import script from "./chatRecordQuery.vue?vue&type=script&lang=ts"
export * from "./chatRecordQuery.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aaa54a2",
  null
  
)

export default component.exports